export const getters = {
  resumes: state => state.resumes,
  currentMode: state => state.currentMode,
  metrics: state => state.metrics,
  resumeById: state => id => {
    return state.resumes.items.find(item => item.resume.find(r => r.id === id));
  },
  currentResume: state => state.currentResume,
  templates: state => state.templates,
  activeColorPalette: state => state.activeColorPalette,
  contacts: state => state.contacts,
  isFetching: state => type => {
    return state.fetchingData[type];
  },
  loading: state => state.loading,
  savingResume: state => state.savingResume,
  leftPannelWidth: state => state.leftPannelWidth,
  searchResult: state => state.searchResult,
  resetSearch: state => state.resetSearch,
  emailNotification: state => state.emailNotification,
  undo: state => state.undo,
  redo: state => state.redo,

  batchId: state => state.batchId,
  batchInfo: state => state.batchInfo,
  fetchingBatchError: state => state.fetchingBatchError,
};
